<lib-modal-layout [title]="title()" [subtitle]="subTitle()">
  <form [formGroup]="form">
    <div class="flex flex-col">
      <div class="w-full">
        <lib-form-text-area label="Notes" formControlName="underwriterNotes" [rows]="5"></lib-form-text-area>
      </div>
    </div>
    <div class="flex items-center justify-center mt-4">
      <lib-button (click)="submit()" [buttonType]="'button'" [cssType]="'btn-primary'"
        [text]="'Void'">
      </lib-button>
    </div>
  </form>
</lib-modal-layout>
